export default {
  header: {},
  body: {
    headline: 'Zugriff verweigert!', // TODO i18n?
    paragraphs: [
      {
        paragraphType: 'text',
        text: `
          <span>
            <p>Sie haben nicht die erforderliche Berechtigung für diese Seite!</p>
            <p>Bitte loggen Sie sich ein oder wenden Sie sich an den Support!</p>
            <p>Ihr Service-Team</p>
          </span>
        `
      }
    ]
  },
  pageMeta: {},
  metaData: {}
}
